import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../button';
import { useFindInViewFilterContext } from './find-in-view-filter-provider';

const ClearFindInViewFilter = ({ message }: { message: ReactNode }) => {
  const { closeAndReset, showFindInView } = useFindInViewFilterContext();

  if (!showFindInView) return null;

  return (
    <div className="flex flex-row gap-1 items-center p-2">
      {message}
      <Button variant="ghost" onClick={closeAndReset} className="text-xs  p-1">
        Clear Filters <X className="size-2" />
      </Button>
    </div>
  );
};

export default ClearFindInViewFilter;
